import { v4 as uuidv4 } from 'uuid';

import { supabase } from '@/lib/supabase';

const schoolId = import.meta.env.VITE_SCHOOL_ID;

export interface SettingsMutation {
	id: string;
	statement: string;
	statementTitle: string;
	primaryColor: string;
	banner: string;
	logo: string;
	labelConfig?: Record<string, string>;
}

export const updateSettings = async (variables: Partial<SettingsMutation>) => {
	const { id, statement, statementTitle, primaryColor, banner, logo, labelConfig } = variables;

	// Ensure non-null values for required fields
	const sanitizedData = {
		id: id || uuidv4(),
		statement: statement || '',
		statement_title: statementTitle || '',
		primary_color: primaryColor || '',
		banner: banner || null,
		logo: logo || null,
		label_config: labelConfig ?? {},
		school_id: schoolId,
	};

	// Use upsert (insert with on conflict update)
	const { data, error } = await supabase
		.from('site_settings')
		.upsert(sanitizedData, {
			onConflict: 'id',
		})
		.select('id, statement_title, statement, primary_color, banner, logo, label_config')
		.single();

	if (error) throw error;

	return {
		id: data.id,
		statement_title: data.statement_title,
		statement: data.statement,
		primary_color: data.primary_color,
		banner: data.banner,
		logo: data.logo,
		label_config: data.label_config,
	} as any;
};
